import { render } from "./corpList.vue?vue&type=template&id=9b457b08"
import script from "./corpList.vue?vue&type=script&lang=js"
export * from "./corpList.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__